import defaultIcon from './extensions/menu/default';

export default function getIcon({ id }) {
  const idString = parseInt(id);
  switch (idString) {
    default:
      return defaultIcon();
  }
}
